package com.advaita.cloud.drive.shared

import kotlinx.serialization.Serializable

/**
 * The identity a re-selected file must match to resume a persisted session.
 * All three fields must be equal — strictest safe guard against resuming into
 * the wrong file. Serialized inside the encrypted IndexedDB blob on the JS side.
 */
@Serializable
data class FileIdentity(
    val name: String,
    val size: Long,
    val lastModified: Long,
) {
    fun matches(other: FileIdentity): Boolean =
        name == other.name && size == other.size && lastModified == other.lastModified
}
